// Recuperación de interés: recuerda el último tour visto sin comprar.
//
// Sólo datos del producto y un borrador de la selección. Nunca datos del
// cliente (nombre, correo, teléfono, dirección) ni información de pago.
// Vigencia: 30 días. Almacenamiento: localStorage del visitante.
const KEY = "mm:recent-tour:v1";
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

export interface RecentTour {
  id: string;
  slug: string;
  title: string;
  destination: string | null;
  image: string | null;
  priceFrom: number | null;
  currency: string;
  /** ISO de la última visita. */
  seenAt: string;
  /** Borrador: nunca se presenta como disponibilidad garantizada. */
  draft?: {
    date?: string | null;
    startTime?: string | null;
    startTimeId?: number | null;
    qty?: Record<string, number>;
  };
}

function read(): RecentTour | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as RecentTour;
    if (!parsed?.slug || !parsed.seenAt) return null;
    if (Date.now() - new Date(parsed.seenAt).getTime() > TTL_MS) {
      window.localStorage.removeItem(KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function getRecentTour(): RecentTour | null {
  return read();
}

export function saveRecentTour(next: Omit<RecentTour, "seenAt">): void {
  if (typeof window === "undefined") return;
  try {
    const prev = read();
    const merged: RecentTour = {
      ...next,
      draft: { ...(prev?.slug === next.slug ? prev.draft : undefined), ...next.draft },
      seenAt: new Date().toISOString(),
    };
    window.localStorage.setItem(KEY, JSON.stringify(merged));
  } catch {
    /* almacenamiento bloqueado: la página sigue funcionando */
  }
}

/** Borra el seguimiento (descarte manual o compra confirmada). */
export function clearRecentTour(slug?: string): void {
  if (typeof window === "undefined") return;
  try {
    if (slug) {
      const prev = read();
      if (prev && prev.slug !== slug) return;
    }
    window.localStorage.removeItem(KEY);
  } catch {
    /* noop */
  }
}
